import SKU_PLAN_ASSET from "../../../../utilities/assets/SKU_PLAN";
import {numberFormat} from "../../../../utilities/moneyFormat";

const formSkuTablePriceWithUnitsString = ({skuPlan, perObjectPrice, language, t, arePricesAndAmountExtended}) => {
  if (!skuPlan || !perObjectPrice) return "";
  const SKU_PLAN = new SKU_PLAN_ASSET(skuPlan, language);

  // const unitPart = `${
  //   !SKU_PLAN.isPieceProduct
  //     ? `${numberFormat(+perObjectPrice / SKU_PLAN.quantityPerSaleObject ?? 1)} ${t("for")} ${
  //         SKU_PLAN.measurementUnitName
  //       }`
  //     : ""
  // }`;
  // const objectPart = `${numberFormat(perObjectPrice)} ${
  //   SKU_PLAN.isMeasurementObjectName ? `${t("for")} ${SKU_PLAN.measurementObjectName ?? t("Type of Selling")}` : ""
  // }`;

  // if (perObjectPrice && unitPart && !arePricesAndAmountExtended) return unitPart;

  // return perObjectPrice ? `${unitPart ? `${unitPart} ${t("or")}` : ""} ${objectPart}` : "";

  return numberFormat((+perObjectPrice * 100) / SKU_PLAN.quantityPerSaleObject / 100 ?? 1);
};

//Колонка  -- Ціна (Є) -- для таблиц в КПф, в модалке добавления СКЮ к КПф и формирования пдф КПф
export const formSkuTablePriceString = ({averageSalesPrice, skuPlan, language, t, arePricesAndAmountExtended}) => {
  const SKU_PLAN = new SKU_PLAN_ASSET({...skuPlan, skuPlanPrice: {...skuPlan?.skuPlanPrice, averageSalesPrice}});

  return formSkuTablePriceWithUnitsString({
    skuPlan,
    language,
    t,
    perObjectPrice: SKU_PLAN.pricePerSaleObject,
    arePricesAndAmountExtended,
  });

  // return numberFormat((SKU_PLAN.pricePerSaleObject * 100) / SKU_PLAN.quantityPerSaleObject / 100);
};

//Колонка  -- Спец ціна (Є) -- для таблиц в КПф, в модалке добавления СКЮ к КПф и формирования пдф КПф
export const formSkuTableSpecPriceString = ({skuPlan, language, t, arePricesAndAmountExtended}) => {
  const SKU_PLAN = new SKU_PLAN_ASSET(skuPlan, language);

  return formSkuTablePriceWithUnitsString({
    skuPlan,
    language,
    t,
    perObjectPrice: SKU_PLAN.specialPricePerObject,
    arePricesAndAmountExtended,
  });
  // return numberFormat((SKU_PLAN.specialPricePerObject * 100) / SKU_PLAN.quantityPerSaleObject / 100);
};

//Колонка  -- Заг.ціна (Є) -- для таблиц в КПф, в модалке добавления СКЮ к КПф и формирования пдф КПф
export const formSkuTableTotalSumString = ({skuPlan, language, t, arePricesAndAmountExtended}) => {
  const SKU_PLAN = new SKU_PLAN_ASSET(skuPlan, language);

  return formSkuTablePriceWithUnitsString({
    skuPlan,
    language,
    t,
    perObjectPrice: SKU_PLAN.finalPricePerObject,
    arePricesAndAmountExtended,
  });

  // return numberFormat((SKU_PLAN.finalPricePerObject * 100) / SKU_PLAN.quantityPerSaleObject / 100);
};

//Колонка  -- Кількість -- для таблиц в КПф, в модалке добавления СКЮ к КПф и формирования пдф КПф
export const formSkuTableAmount = ({skuPlan, language, t, arePricesAndAmountExtended}) => {
  if (!skuPlan) return "";
  const SKU_PLAN = new SKU_PLAN_ASSET(skuPlan, language);

  const unitPart = `${numberFormat(SKU_PLAN.totalQuantity, 3)} ${SKU_PLAN.measurementUnitName} `;
  const objectPart = `${SKU_PLAN.amount} ${SKU_PLAN.measurementObjectName}`;

  // return SKU_PLAN.isPieceProduct
  //   ? `${SKU_PLAN.totalQuantity} ${SKU_PLAN.measurementObjectName}`
  //   : arePricesAndAmountExtended
  //   ? `${unitPart} ${t("or")}  ${objectPart}`
  //     : unitPart;

  return numberFormat(SKU_PLAN.totalQuantity);
};
